<div class="px-4 pt-4 pb-20 h-full bg-neutral-5">
  <maximizer-summary-task
    [type]="type()"
    [id]="id()"
    [deepLink]="deepLink()"
    (loadErrorEvent)="showNotification($event)"
  ></maximizer-summary-task>

  <maximizer-summary-note
    [id]="id()"
    [deepLink]="deepLink()"
    [lead]="lead()"
    [abentry]="abentry()"
    (loadErrorEvent)="showNotification($event)"
  ></maximizer-summary-note>

  <maximizer-summary-appointment
    [id]="id()"
    [type]="type()"
    [deepLink]="deepLink()"
    (loadErrorEvent)="showNotification($event)"
  ></maximizer-summary-appointment>

  @if (userRights?.opportunities?.read && type() === 'abentry') {
    <maximizer-summary-opportunity
      [id]="id()"
      [deepLink]="oppLink()"
      (loadErrorEvent)="showNotification($event)"
    ></maximizer-summary-opportunity>
  }

  @if (userRights?.customerService?.read && type() === 'abentry') {
    <maximizer-summary-case
      [id]="id()"
      [deepLink]="csLink()"
      (loadErrorEvent)="showNotification($event)"
    ></maximizer-summary-case>
  }
</div>

<maximizer-outlook-notification
  #notification
  [closable]="true"
  entryId="summary"
>
</maximizer-outlook-notification>
